import TextLong from "./TextLong";
export default TextLong;
